import { useDynamicEntityStoreContext } from './contexts';

import SimpleSettings from './_simple_sidebar/SimpleSettings';
import ComponentsList from './_builder_sidebar/ComponentsList';
import ComponentSelectionPane from './_builder_sidebar/ComponentSelectionPane';
import ComponentSettingsPane from './_builder_sidebar/ComponentSettingsPane';

function SimpleTabs({ SIMPLE_TABS }) {
  const activeTab = useDynamicEntityStoreContext((state) => state.activeTab);

  return <div className="dp-inner-container">{SIMPLE_TABS[activeTab].component}</div>;
}

function SimpleTabsNavigation({ SIMPLE_TABS }) {
  const activeTab = useDynamicEntityStoreContext((state) => state.activeTab);
  const update = useDynamicEntityStoreContext((state) => state.update);

  return (
    <div className="dp-editor-sidebar-bottom">
      {SIMPLE_TABS.map((tab, index) => (
        <button key={index} className="navigation-button" onClick={() => update({ activeTab: index })}>
          <div className={`button-content ${activeTab === index && 'active-tab'}`}>
            <div className="tab-number">{index + 1}</div>
            <span>{tab.label}</span>
          </div>
        </button>
      ))}
    </div>
  );
}

function TopNavigation({ buttons }) {
  const update = useDynamicEntityStoreContext((state) => state.update);

  return buttons.map((button, index) => (
    <button key={index} className="navigation-button" onClick={() => update({ activePane: button.toPane })}>
      {button.icon && <i className={`fe ${button.icon}`} />}
      {button.label}
      {button.iconEnd && <i className={`fe ${button.iconEnd}`} />}
    </button>
  ));
}

export default function SimpleSidebar() {
  const activePane = useDynamicEntityStoreContext((state) => state.activePane);

  const SIMPLE_TABS = [
    {
      label: 'Settings',
      component: <SimpleSettings />,
    },
    {
      label: 'Content',
      component: <ComponentsList {...{ toActivePaneAfterEdit: 2, toActivePaneAfterAdd: 1, description: "Configure this module's content" }} />,
    },
  ];

  const SIDEBAR_PANE = [
    // 0
    {
      label: 'Page Builder',
      buttons: [],
      component: (
        <>
          <SimpleTabs {...{ SIMPLE_TABS }} />
          <SimpleTabsNavigation {...{ SIMPLE_TABS }} />
        </>
      ),
    },
    // 1
    {
      label: 'Component Selection',
      buttons: [{ label: 'Back', icon: 'fe-arrow-left', toPane: 0 }],
      component: (
        <div className="dp-inner-container">
          <ComponentSelectionPane {...{ toActivePaneAfterAdd: 0 }} />
        </div>
      ),
    },
    // 2
    {
      label: 'Edit Component',
      buttons: [{ label: 'Back', icon: 'fe-arrow-left', toPane: 0 }],
      component: (
        <div className="dp-inner-container">
          <ComponentSettingsPane />
        </div>
      ),
    },
  ];

  return (
    <div className="dp-editor-sidebar pt-3">
      <div className="dp-editor-sidebar-top">
        <TopNavigation {...{ buttons: SIDEBAR_PANE[activePane].buttons }} />
      </div>
      <div className={`dp-editor-sidebar-main-container ${SIDEBAR_PANE[activePane]?.buttons?.length ? 'shorter' : ''}`}>
        {SIDEBAR_PANE[activePane].component}
      </div>
    </div>
  );
}
